export const sampleCard = [
  {
    id: 1,
    title: "Sortie",
    content: "Diner avec Émilie",
    status: "todo",
  },
  {
    id: 2,
    title: "Travail",
    content: "Rendre rapport 2XE3C",
    status: "do",
  },
  {
    id: 3,
    title: "Achats",
    content: "Acheter du savon",
    status: "todo",
  },
];
